// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3Zl6H","cell":"ColumnAccessor_cell__1YSSR","firstCellAccent":"ColumnAccessor_firstCellAccent__1hVvB"};